module.exports = __webpack_public_path__ + "img/asc-logo.d02c6ba4.jpg";